// removed by extract-text-webpack-plugin
module.exports = {"setting":"_2iqzNuulgIbfigZ72y-yyl","icon":"vixVF8duYJvYp4xiZJoS6"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/settings/styles.css
// module id = 1554
// module chunks = 0